<template>
  <div>
    {{getSupportComment}}
    <div class="mt-1">
      <div v-if="formData.ticket_id">
        <form class="mt-2" id="form-modal">
          <!-- description input -->
          <div class="form-group bottomBorder">
            <label class="label-form">Note:</label>
            <div class="comment-input">
              <tiny-mce-editor
                  :vModelName.sync="support_comment"
                  :media="false"
                  :idEditor="editorId"
                  :height="height"
                  @onInput="onInput"
                  @handleKeydown="handleKeydown"
                  ref="textarea"
                  rows="6"
                  placeholder="Add Note here...">
              </tiny-mce-editor>

              <!--  { top: top > 44 && top < 170 ? `${top}px` : `${lastTop}px` } -->

              <div  class="suggestions" :style="{ top: top > 44 && top < 170 ? `${top}px` : `${lastTop}px` }" >
                <div v-if="showSuggestions && filteredUsers.length>0" class="suggestions-container" style="overflow-y: auto; max-height:200px;">
                  <ul>
                    <li v-for="(user, index) in filteredUsers"
                        :key="user.id"
                        :class="{ 'active': index === selectedIndex ,  'highlighted': index === selectedIndex}"

                        @click="selectUser(user)">
                      {{ user.username }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="buttonWrapper mt-4">
                <button type="button" class="btn btn-default send-btn"  :style= "[mini_loading ? { 'pointer-events' : 'none' } : { 'pointer-events' : 'auto' }]" @click="save">
                  <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="createNotesForm" v-else>
        <form
            class="forms-sample"
            style="border-radius: 10px; border: 1px solid gainsboro"
        >
          <!-- body input -->
          <div class="form-group">
            <div class="text_editor">
              <tiny-mce-editor
                  :vModelName.sync="support_comment"
                  :media="false"
                  :idEditor="editorId"
                  :height="height"
                  @onInput="onInput"
                  @handleKeydown="handleKeydown"
                  ref="textarea"
                  rows="6"
                  placeholder="Add Note here...">
              </tiny-mce-editor>
              <div  class="suggestions" :style="{ top: top > 44 && top < 170 ? `${top}px` : `${lastTop}px` }" >
                <div v-if="showSuggestions && filteredUsers.length>0" class="suggestions-container" style="overflow-y: auto; max-height:170px;">
                  <ul>
                    <li v-for="(user, index) in filteredUsers"
                        :key="user.id"
                        :class="{ 'active': index === selectedIndex ,  'highlighted': index === selectedIndex}"

                        @click="selectUser(user)">
                      {{ user.username }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="text-right">
            <button type="button" class="btn addNotes"  :style= "[mini_loading ? { 'pointer-events' : 'none' } : { 'pointer-events' : 'auto' }]" @click="save">
              <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />Save</button>
          </div>
        </form>
      </div>
    </div>
    <div v-if="formData.ticket_id"  class="mt-3 scrollable-div" >
      <div class="vtl" v-for="(comment,index) in comments" :key="index">
        <div class="event">
          <strong class="edate">{{comment.created_at}}</strong>
          <p style="white-space: pre-line;" class="etxt"><b>{{ comment.user.first_name }} {{ comment.user.last_name }} </b> commented <div v-html="comment.comment"></div>
          </p>
        </div>
      </div>
      <div class="text-center" v-if="comments.length<1">
        <h4 class="my-5 py-5">No Note Found</h4>
      </div>
    </div>

  </div>
</template>

<script>

import axios from "axios";
import TinymceEditor from "@/views/partials/tiny_mce_editor";
import {isEmpty} from "lodash/lang";



export default {
  props: ["action", "formData", "height", "editorId"],
  components: {
    "tiny-mce-editor": TinymceEditor,
  },


  data: function () {
    return {
      support_comment:'hello dear good night for me',
      renderedContent:'',
      comments: {},
      mini_loading:false,
      users: [],
      filteredUsers: [],
      showSuggestions: false,
      searchQuery: '',
      selectedIndex: 0,
      selected_user: [],
      isHighlighted: false,
      top: 0,
      lastTop:44,
    };
  },
  created(){
    let users = this.$store.getters['users/assignToUser'];
    this.users = users.filter(user => user.id  !=  localStorage.getItem('admin_id'));
    // this.filteredUsers = users.filter(user => user.id  !=  localStorage.getItem('admin_id'));
  },
  mounted() {
    if (this.formData.ticket_id)
      this.getComments();
  },
  computed: {
    Note: function () {
      return this.$store.getters['users/leadNotes'];
    },
    getSupportComment() {
      if (this.formData.ticket_id)
        this.getComments();
      this.support_comment='';
      this.showSuggestions = false;
    },

  },
  watch:{
    support_comment(newVal, oldVal) {
      this.selected_user.forEach(user => {
        const tag = `@${user.username}`;
        if (!newVal.includes(tag) && oldVal.includes(tag)) {
          this.filteredUsers.push(user);
          this.selected_user = this.selected_user.filter(selected => selected !== user);
        }
      });
    }
  },

  methods: {
    isEmpty,
    save() {
      let ticket_id = this.formData.ticket_id;
      let lead_id = this.formData.lead_id;
      let organization_id = this.formData.organization_id;
      let message_id = this.formData.message_id;
      let support_comment = this.support_comment;
      let tkt_id = this.formData.tkt_id;
      if (support_comment.trim().length === 0) {
        this.$toast.error("Note is required");
        return false;
      }



      this.mini_loading = true;
      this.$store
        .dispatch("support/saveComment", [support_comment, ticket_id || tkt_id, this.selected_user, lead_id, organization_id,message_id])
        .then(() => {
          this.$toast.success("Note added Successfully");
          this.support_comment = '';
          if (ticket_id !== undefined) {
            this.getComments();
            this.$store.dispatch("support/getAllTickets", [this.formData.page, this.formData.ticket_current_status, '', false])
              .then(() => {
                this.showskLoader = false;
              });
          }

          if (lead_id !== undefined) {
            this.support_comment = '';
            this.$store.dispatch('users/getLeadNotes', ["lead_id", lead_id])
            this.showskLoader = false;
            this.$emit("updateNoteTabValue", true);
          }

          if (organization_id !== undefined) {
            this.support_comment = '';
            this.$store.dispatch('users/getLeadNotes', ["organization_id", organization_id]);
            this.showskLoader = false;
            this.$emit("updateNoteTabValue", true);
          }

          if (message_id !== undefined){
            this.support_comment = '';
            this.$parent.getMessageComments(message_id,1,support_comment,this.formData.index);

            this.showskLoader = false;
          }
          this.mini_loading = false;
          this.showSuggestions = false;
        })
        .catch((error) => {
          this.$toast.error("something went wrong");
          this.support_comment = '';
          this.mini_loading = false;
        });
    },
    onInput(e,l) {

      if (l.key === '@') {
        this.showSuggestions = true;
        this.filteredUsers = this.users
        this.filteredUsers = this.filteredUsers.filter(user => !this.selected_user.includes(user));
      }else{
        // const contentBeforeCursor = e.getContent({ format: 'text' });
        // const atIndex = contentBeforeCursor.lastIndexOf('@');

        // // Check if '@' is present and we're typing after it
        // if (atIndex !== -1) {
        //   // Extract the text after '@'
        //   const textAfterAt = contentBeforeCursor.slice(atIndex + 1);

        //   // Check if the text after '@' equals 'abc'
        //   if (textAfterAt.length>0) {
        //     console.log('The user typed');
        //     // Trigger your desired action when @abc is typed
        //     // this.handleAtAbcDetected();
        //   }
        // }
        // this.showSuggestions = true;


        // console.log('editor content', editor.getContent());

        // const cursorPosition = e.target.selectionStart;

        //
        // const textarea = this.$refs.textarea;

        //   const lines = textarea.value.substr(0, cursorPosition).split('\n');
        //   const lineNumber = lines.length;
        //  if(lineNumber<5 && lineNumber>1)
        //  {
        //   const lineHeight = 40;
        //   this.top = lineNumber * lineHeight;
        //  }else if(lineNumber == 1){
        //    this.top = cursorPosition;
        //  }

        //    if(this.top>170){
        //     this.lastTop = 170;
        //    }else{
        //     this.lastTop = 44;
        //    }
        // const textBeforeCursor = this.support_comment.slice(0, cursorPosition);
        const editor = tinymce.get();
        const content = e.getContent();
        const selection = e.selection;
        const start = selection.getRng().startOffset;
        const end = selection.getRng().endOffset;



        if(start<170){
          this.lastTop = 150 + start;
        }
        const contentBeforeCursor = e.getContent({ format: 'text' });

        const atIndex = contentBeforeCursor.lastIndexOf('@');
        const substringAfterAt = contentBeforeCursor.slice(atIndex + 1);
        if (atIndex === -1 && l.key !== 'ArrowDown' && l.key !== 'ArrowUp' && l.key !== 'Enter') {
          this.showSuggestions = false;
          this.searchQuery = '';
          return;
        }

        if (substringAfterAt.trim() === '' && l.key !== 'ArrowDown' && l.key !== 'ArrowUp' && l.key !== 'Enter') {
          this.showSuggestions = false;
          this.searchQuery = '';
          return;
        }



        if (atIndex !== -1) {
          // const substringAfterAt = contentBeforeCursor.slice(atIndex + 1);
          if(/^[^\s]*$/.test(substringAfterAt)) {
            this.searchQuery = substringAfterAt;

            if (this.searchQuery.length > 0) {
              this.filteredUsers = this.users.filter(user =>
                  user.username.toLowerCase().includes(this.searchQuery.toLowerCase())
              );

              this.filteredUsers = this.filteredUsers.filter(user => !this.selected_user.includes(user));

              this.showSuggestions = this.filteredUsers.length > 0;
            }else{
              this.filteredUsers = this.filteredUsers.filter(user => !this.selected_user.includes(user));

            }
          }
        }
      }

    },
    selectUser(user, editor, e) {
      const iframeId = this.editorId !== 'undefined' ? `editor${this.editorId}_ifr` : 'editor_ifr';
      const iframe = document.getElementById(iframeId);
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

      const selection = iframeDocument.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        console.log("range =>", range);
        if (range.startOffset === 0 && range.endOffset === 0){
          range.startOffset = 2;
          range.endOffset = 2;
        }
        const container = range.commonAncestorContainer;

        if (container.nodeType === Node.TEXT_NODE || container.nodeType === 1) {
          const textContent = container.textContent;
          const atIndex = textContent.lastIndexOf('@', range.endOffset);

          if (atIndex !== -1 ) {
            const tag = iframeDocument.createElement('span');
            tag.setAttribute('style', 'line-height: 18px; color: white; background: #48a6a6; padding: 4px; border-radius: 6px; font-size: 14px; display:inline-block; margin-bottom:4px; margin-right:2px;');
            tag.setAttribute('contenteditable', 'false');
            tag.innerHTML = `@${user.username}`;

            const beforeAt = textContent.slice(0, atIndex);
            const afterAt = textContent.slice(atIndex + 1);

            // Clear existing text and insert the user tag
            container.textContent = beforeAt;
            range.setStart(container, beforeAt.length);
            range.insertNode(tag);

            // Move the cursor after the inserted tag
            const space = iframeDocument.createTextNode(afterAt);
            range.setStartAfter(tag);
            range.insertNode(space);
            range.setStartAfter(space);
            range.setEndAfter(space);

            // Update the selection with the new range
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }

        this.showSuggestions = false;
        this.searchQuery = '';

        if (!this.selected_user.includes(user)) {
          this.selected_user.push(user);
        }
      }
    },

    handleKeydown(editor,e) {
      // alert('come');
      const itemCount = 5;

      if (e.keyCode === 32) {
        this.showSuggestions = false;
      }

      if (this.showSuggestions) {
        if (e.key === 'ArrowDown') {
          // alert('down');
          e.preventDefault();
          this.selectedIndex = (this.selectedIndex + 1) % this.filteredUsers.length;
          this.isHighlighted = true;
          this.scrollToSelected();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.selectedIndex = (this.selectedIndex - 1 + this.filteredUsers.length) % this.filteredUsers.length;
          this.scrollToSelected();
        }
        else if (e.key === 'Enter') {
          e.preventDefault();
          this.showSuggestions = false;
          this.selectUser(this.filteredUsers[this.selectedIndex], editor,e);

        }
      }
    },

    scrollToSelected() {
      this.$nextTick(() => {
        const container = this.$el.querySelector('.suggestions-container');
        const selectedItem = container.querySelector('.active');
        if (container && selectedItem) {
          const containerTop = container.scrollTop;
          const containerHeight = container.clientHeight;
          const itemTop = selectedItem.offsetTop;
          const itemHeight = selectedItem.clientHeight;

          // Adjust scroll position if needed
          if (itemTop < containerTop) {
            container.scrollTop = itemTop;
          } else if (itemTop + itemHeight > containerTop + containerHeight) {
            container.scrollTop = itemTop + itemHeight - containerHeight;
          }
        }
      });
    }
    ,
    getComments(){
      const permission = {
        headers: {
          'X-Permission': 'all_tickets_view'
        }
      };
      axios
          .get("/admin/support/get-ticket/comment?ticket_id=" + this.formData.ticket_id,permission)
          .then((response) => {
            this.comments = response.data.comments;
            return response.data;
          });
    },
    close(){
      this.support_comment = ''; // Reset the editor's content variable
      this.showSuggestions = false;
    }
  },


};
</script>
<style>
/* Optional: Add custom styling for the placeholder if needed */
.tagSpanNew{
  color: white;
  background: #48a6a6;
  padding: 4px;
  border-radius: 6px;
  font-size: 14px;
}
.scrollable-div {
  height: calc(100vh - 172px);
  width: 100%; /* Optional: Set the width */
  overflow-y: auto; /* Auto-show/hide vertical scrollbar */
  overflow-x: hidden;
  padding: 10px; /* Optional: Add padding */

}
.scrollable-div::-webkit-scrollbar {
  width: 10px;
}
.scrollable-div::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 3px;
}

.scrollable-div::-webkit-scrollbar-thumb {
  background: #48a6a6;
  border-radius: 3px;
}
.scrollable-div p{
  word-break: break-word;
}
.comment-input{
  background: #FFFFFF;
  border: 0;
  border-radius: 4px;
  position: relative;
}
.comment-input{
  padding: 12px 16px 12px 16px;
  resize: none;
  border: 0;
  box-shadow: none;
  outline: none;
  width: 100%;
  background: #FFFFFF;
  border: 0;
  border-radius: 4px;
  position: relative;
}
.comment-input .ProseMirror {
  padding: 0;
  resize: none;
  border: 0;
  box-shadow: none;
  outline: none;
  width: 100%;
  background: #FFFFFF;
  border: 0;
  border-radius: 2px;
  position: relative;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.ProseMirror p{
  margin-bottom: 4px !important;
  padding: 4px 0;
}
.mention{
  border: 1px solid #48A6A6 !important;
  background-color: #48A6A6;
  color: #FFF;
  border-radius: 4px;
  min-width: fit-content;
  display: inline-block;
  margin-bottom: 4px;
  padding: 4px 8px !important;
  text-align: center;
}
.comment-input .ProseMirror::-webkit-scrollbar {
  width: 4px;
}
.comment-input .ProseMirror::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 3px;
}

.comment-input .ProseMirror::-webkit-scrollbar-thumb {
  background: #48a6a6;
  border-radius: 3px;
}
.comment-input .ProseMirror:focus{
  box-shadow: none;
}
.comment-input .buttonWrapper{
  width: 100px;
  margin: 0 0 0 auto;
  text-align: end;
  margin-top: 4px;
}
.comment-input .send-btn{
  padding: 6px 16px 6px 16px;
  border-radius: 4px;
  background: #48A6A6;
  font-weight: 600;
  text-align: center;
  color:#FFFFFF;
  margin: 0;
}
.bottomBorder{
  border-bottom:1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 17px;
}
</style>

<style scoped>
.mention-container {
  position: relative;
}

.suggestions {
  position: absolute;
  background: white;
  z-index: 10;
  width: 93%;
  top: 44px;
  border-radius: 6px;
}

.suggestions ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.suggestions li {
  padding: 8px;
  cursor: pointer;
  background-color: #48a6a62e !important;
  border-bottom: 1px solid #48a6a6;
}

.suggestions li.active {
  background-color: #eee;
}
.suggestions li:hover{
  background: #48A6A6 !important;
  color: #fff;
}
.selectedUser{
  background: #48A6A6 !important;
  color: #fff;
  padding: 2px 6px;
  text-align: center;
  font-size: 12px;
}
.suggestions ul li.highlighted {
  /* Add your styling here */
  background: #48A6A6 !important;
  color: #fff;
}
textarea{
  resize: none;
}
/* width */
.suggestions-container::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.suggestions-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.suggestions-container::-webkit-scrollbar-thumb {
  background: #48a6a6;
}

/* Handle on hover */
.suggestions-container::-webkit-scrollbar-thumb:hover {
  background: #48a6a6;
}
</style>
